module.exports = __webpack_public_path__ + "img/arrow-right-circle-white.8da4c7ef.svg";